import { useEffect, useEffectEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ReduxState } from '@a1/shared';
import { setUserData } from 'store/features/userSlice';
import callAzureFunction from 'utils-ts/call-azure-function';
import callAzureFunctionPublic from 'utils-ts/call-azure-function-public';
import handleError from 'utils-ts/handle-error';

const useAccessRoleSync = (): void => {
  const dispatch = useDispatch();
  const userData = useSelector((state: ReduxState) => state.user?.data);

  const refreshAccessRoles = useEffectEvent(async () => {
    try {
      const { data } = await callAzureFunction({ url: '/access-roles/by-user', method: 'get' });
      dispatch(setUserData({ data: { ...userData, AccessRoles: data } }));
    } catch (error) {
      handleError(error);
    }
  });

  useEffect(() => {
    let socket: WebSocket | null = null;
    let closed = false;

    const connect = async () => {
      try {
        const { data } = await callAzureFunctionPublic<{ webSocketUrl?: string }>({
          url: '/websocket_connect_access_roles',
          method: 'get'
        });

        if (closed || !data?.webSocketUrl) return;

        socket = new WebSocket(data.webSocketUrl);
        socket.addEventListener('message', () => void refreshAccessRoles());
      } catch (error) {
        handleError(error);
      }
    };

    void connect();

    return () => {
      closed = true;
      socket?.close();
      socket = null;
    };
  }, []);
};

export default useAccessRoleSync;
